import {Vue} from "ui.vue";

const COMPONENT_NAME = 'citrus:announcement';
const COMPONENT_METHOD = 'load';
const COMPONENT_METHOD_CLOSE = 'close';

export let CitrusAnnouncementList = {
	name: "CitrusAnnouncementList",
	data: () => {
		return {
			loading: false,
			list: false
		}
	},
	created() {
		this.refresh();
	},
	methods: {
		refresh() {
			this.loading = true;

			BX.ajax.runComponentAction(COMPONENT_NAME,
				COMPONENT_METHOD, {
					mode: 'class',
					data: {},
					signedParameters: this.signedParameters
				})
				.then((response) => {
					this.$set(this, 'list', response.data);
				})
				.catch((error) => {
					console.log(error);
				})
				.finally((error) => {
					this.loading = false;
				})
			;
		},
		close(id)
		{
			BX.ajax.runComponentAction(COMPONENT_NAME,
				COMPONENT_METHOD_CLOSE, {
					mode: 'class',
					data: {elementId: id},
					signedParameters: this.signedParameters
				})
				.then((response) => {
					let id = parseInt(response.data);
					let list = this.list.filter((element) => element.ID != id);

					this.$set(this, 'list', list);
				})
				.catch((error) => {
					console.log(error);
				})
				.finally((error) => {
					this.loading = false;
				})
			;
		}
	},
	computed: {
		loc() {
			return Vue.getFilteredPhrases(this.locPrefix);
		}
	}
};
